import * as React from 'react';

/**
 * Click-to-copy state, shared by everything in the launcher that offers it.
 *
 * Clipboard access is permission-gated and absent outside a secure context, so
 * a refusal leaves the text on screen to select by hand rather than claiming a
 * copy that did not happen.
 */
export const useCopy = () => {
  const [copied, setCopied] = React.useState(false);
  const timer = React.useRef<ReturnType<typeof setTimeout>>();

  React.useEffect(() => () => clearTimeout(timer.current), []);

  const copy = React.useCallback((text: string) => {
    clearTimeout(timer.current);
    navigator.clipboard?.writeText(text).then(
      () => {
        setCopied(true);
        timer.current = setTimeout(() => setCopied(false), 1500);
      },
      () => setCopied(false),
    );
  }, []);

  return { copied, copy, reset: () => setCopied(false) };
};
